import { React, useState } from "react";
import { AddPhotoAlternate } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth, storage, db } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { doc, setDoc } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";

export default function Register() {
  const [error, setError] = useState("");
  const [avatar, setAvatar] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    const fileUrl = URL.createObjectURL(file);
    setAvatar(fileUrl);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const displayName = e.target[0].value;
    const email = e.target[1].value;
    const file = e.target[3].files[0];
    setLoading(true);
    //FIREBASE
    try {
      const res = await createUserWithEmailAndPassword(auth, email, password);
      const storageRef = ref(storage, displayName);
      const uploadTask = uploadBytesResumable(storageRef, file);
      uploadTask.on(
        (uploadError) => {
          setError(uploadError.code);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
            //Update profile
            await updateProfile(res?.user, {
              displayName,
              photoURL: downloadURL,
            });
            //
            let query = [];
            let currentQuery = "";
            for (let index = 0; index < displayName.length; index++) {
              const element = displayName[index];
              currentQuery += element;
              query.push(currentQuery.toLowerCase());
            }
            //create user on firestore
            await setDoc(doc(db, "users", res.user.uid), {
              uid: res.user.uid,
              displayName,
              email,
              photoURL: downloadURL,
              query,
            });

            //create empty user chats on firestore
            await setDoc(doc(db, "userChats", res.user.uid), {});
            navigate("/");
          });
        }
      );
    } catch (err) {
      setError(err.code);
    }
    setLoading(false);
  };

  return (
    <div className="formContainer">
      <div className="formWrapper">
        <span className="logo">Chatmore</span>
        <span className="title">Register</span>
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="display name" required/>
          <input type="email" placeholder="email" required/>
          <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type={showPassword ? "text" : "password"} placeholder="password" required/>
            <span style={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}>
              {password && (showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />)}
            </span>
          </div>
          <input
            type="file"
            id="file"
            accept="image/jpeg, image/png"
            style={{ display: "none" }}
            onChange={handleAvatarChange}
          />
          <label htmlFor="file">
            {avatar ? (
              <img
                src={avatar}
                alt="avatar"
                height={30}
                width={30}
                style={{
                  borderRadius: "4px",
                  border: "1px solid black",
                  objectFit: "cover",
                  marginRight: "5px",
                }}
              />
            ) : (
              <AddPhotoAlternate className="icon" />
            )}
            {avatar ? "Change avatar" : "Add an avatar"}
          </label>
          <button type="submit">{loading ? "Registering..." : "Sign up"}</button>
        </form>
        {error && <span className="alert">{error}</span>}
        <p>
          Already have an account? <Link to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
}
